export const getStore = (): any => {
  return sessionStorage.getItem('store') !== null ? JSON.parse(sessionStorage.getItem('store') as string) : null;
};
